import React from "react";
import { Card } from "reactstrap";
import StatisticCard from "../../Utils/Cards/StatisticCard";
/* IMAGE */
const alert_icon = require("assets/img/alert-icons-triangle-alert.svg");
const fire_engine_warning = require("assets/img/fire_truck.svg");
const fire_engine_success = require("assets/img/fire-engine-success.svg");
const fire_engine_danger = require("assets/img/fire-engine-danger.svg");
const user_icon = require("assets/img/user-icon.svg");

import "../dashboard.css";


const CardsHeader = ({ dashboardData }) => {
    return (
        <div className="header-stats-container">
            <div className="stat-card-1">
                <StatisticCard
                    title="Emergencias Activas"
                    color="#ffc107"
                    statistic={
                        dashboardData.emergencies_active
                            ? dashboardData.emergencies_active
                            : 0
                    }
                />
            </div>
            <div className="stat-card-2">
                <StatisticCard
                    title="Emergencias Resueltas"
                    color="#28a745"
                    statistic={
                        dashboardData.emergencies_resolved
                            ? dashboardData.emergencies_resolved
                            : 0
                    }
                />
            </div>
            <div className="stat-card-3">
                <StatisticCard
                    title="Emergencias Críticas"
                    color="#dc3545"
                    statistic={
                        dashboardData.emergencies_critical
                            ? dashboardData.emergencies_critical
                            : 0
                    }
                />
            </div>

            <div className="stat-card-4">
                <StatisticCard
                    title="Estaciones Activas"
                    color="#28a745"
                    statistic={
                        dashboardData.station_active
                            ? dashboardData.station_active
                            : 0
                    }
                />
            </div>
            <div className="stat-card-5">
                <StatisticCard
                    title="Estaciones Inactivas"
                    color="#dc3545"
                    statistic={
                        dashboardData.emergencies_disable
                            ? dashboardData.emergencies_disable
                            : 0
                    }
                />
            </div>
            <div className="stat-card-6">
                <StatisticCard
                    title="Vehículos disponibles / en emergencia"
                    color="#ffc107"
                    statistic={
                        dashboardData.vehicles_disponibility
                            ? dashboardData.vehicles_disponibility
                            : 0
                    }
                    statistic2={
                        dashboardData.vehicles_emergency
                            ? dashboardData.vehicles_emergency
                            : 0
                    }
                    double={true}
                    description={"Diponibles"}
                    description2={"En emergencia"}
                />
            </div>

            {/* Large Card 1: Orange - Emergencias Solicitando Apoyo */}
            <Card className="stat-card-large-1" style={{ borderRadius: '20px', border: 'none' }}>
                <div className="content-info p-3 d-flex flex-column justify-content-between h-100">
                    <div>
                        <img
                            className="mb-2"
                            src={alert_icon}
                            alt="logo-warning.png"
                            style={{ height: '40px', filter: 'brightness(0) invert(1)' }}
                        />
                        <h6 className="title font-weight-bold text-white mb-2" style={{ fontSize: '1.2rem' }}>
                            Emergencias Solicitando Apoyo
                        </h6>
                    </div>
                    <h2 className="font-weight-bold text-white mb-0 text-right display-4">
                        {dashboardData.emergencies_requesting_support
                            ? dashboardData.emergencies_requesting_support
                            : 0}
                    </h2>
                </div>
            </Card>

            {/* Large Card 2: Green - Vehículos Solicitando Apoyo */}
            <Card className="stat-card-large-2" style={{ borderRadius: '20px', border: 'none' }}>
                <div className="content-info p-3 d-flex flex-column justify-content-between h-100">
                    <div>
                        <img
                            className="mb-2"
                            src={fire_engine_warning}
                            alt="logo-user.png"
                            style={{ height: '40px', filter: 'brightness(0) invert(1)' }}
                        />
                        <h6 className="title font-weight-bold text-white mb-2" style={{ fontSize: '1.2rem' }}>
                            Vehículos registrados
                        </h6>
                    </div>
                    <h2 className="font-weight-bold text-white mb-0 text-right display-4">
                        {dashboardData.total_vehicle
                            ? dashboardData.total_vehicle
                            : 0}
                    </h2>
                </div>
            </Card>
        </div>
    );
};

export default CardsHeader;
